export const ClientContextSearchParams = {
  APP: '__app',
  CLIENT: '__client',
} as const;
